import { render, staticRenderFns } from "./FormSopimusLaskutusaihe.vue?vue&type=template&id=ed02017e&scoped=true&"
import script from "./FormSopimusLaskutusaihe.vue?vue&type=script&lang=js&"
export * from "./FormSopimusLaskutusaihe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed02017e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed02017e')) {
      api.createRecord('ed02017e', component.options)
    } else {
      api.reload('ed02017e', component.options)
    }
    module.hot.accept("./FormSopimusLaskutusaihe.vue?vue&type=template&id=ed02017e&scoped=true&", function () {
      api.rerender('ed02017e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormSopimusLaskutusaihe.vue"
export default component.exports